export const MAX_FREQUENTLY_USED_EMOJIS = 9
